import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";

@Injectable({
  providedIn: 'root'
})
export class UnsubscribeService {
  private readonly apiService = inject(BaseApiService);

  async unsubscribe(subscriptionToken: string) {
    return await this.apiService.get(`/email-notification/unsubscribe?subscriptionToken=${subscriptionToken}`);
  }

  async unsubscribeContact(subscriptionToken: string) {
    return await this.apiService.get(`/email-notification/unsubscribe/contact?subscriptionToken=${subscriptionToken}`);
  }

  async subscribe(userId: string, topicId: string) {
    const body = {
      userId: userId,
      topicId: topicId
    }
    return await this.apiService.post(`/email-notification/subscribe`, body);
  }
}
